import { AuthPayload } from "@/interfaces/ui.interface"

export default {
  setGallery(state: any, payload: AuthPayload) {
    state.galleryList = payload
    state.totalItems = payload.data.total
    state.page = payload.data.page
    state.limit = payload.data.limit
  },
  addGalleryItem(state: any, payload: AuthPayload) {
    state.statusInsertGallery = payload
  },
  editGalleryItem(state: any, payload: AuthPayload) {
    state.statusUpdateGallery = payload
  },
  delGalleryItem(state: any, payload: AuthPayload) {
    state.statusDelGallery = payload
  }
}